import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HelpArticleId } from './help-article-ids';

@Component({
  selector: 'app-help-article-link',
  standalone: true,
  imports: [RouterLink],
  template: `
    <a
      [routerLink]="['/help']"
      [fragment]="articleId"
      class="help-article-link"
      [attr.aria-label]="ariaLabel"
      [title]="title"
      target="_blank"
      rel="noopener"
    >?</a>
  `,
  styles: [
    `
      .help-article-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1.15rem;
        height: 1.15rem;
        margin-left: 0.25rem;
        vertical-align: middle;
        text-decoration: none;
        border: 1px solid var(--border-color, #cbd5e1);
        border-radius: 999px;
        background: var(--surface-elevated, #fff);
        color: var(--text-secondary, #64748b);
        font-size: 0.72rem;
        font-weight: 700;
        line-height: 1;
        flex-shrink: 0;
      }
      .help-article-link:hover {
        color: var(--accent-color, #2563eb);
        border-color: color-mix(in srgb, var(--accent-color, #2563eb) 45%, var(--border-color, #cbd5e1));
        background: color-mix(in srgb, var(--accent-soft, #dbeafe) 70%, #fff);
      }
    `,
  ],
})
export class HelpArticleLinkComponent {
  @Input({ required: true }) articleId!: HelpArticleId | string;
  @Input() ariaLabel = '使用幫助';
  @Input() title = '開啟使用幫助';
}
